module.exports = __webpack_public_path__ + "img/GNT.844664d4.svg";